import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import flag_black_icon from 'assets/img/flag-black.svg';
import cube_icon from 'assets/img/cube.svg';

import * as MaintenanceEnums from './maintenance-enums';
import * as ProjectActionType from 'Projects/constants';

class MaintenanceImportTaskSpecific extends React.Component {

    static propTypes = {
      projectId: PropTypes.string,
      dispatch: PropTypes.func,
      suggestedSpecificTaskList: PropTypes.array
    }

    constructor(props) {
      super(props);

      this.state = {
        filterOutItems: {}
      };
    }

    componentDidMount() {
      this.props.dispatch({
        type: ProjectActionType.GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_ASYNC,
        params: {
          projectId: this.props.projectId
        }
      });
    }

    componentWillReceiveProps() {
    }

    // items = [
    //   { id: 1, isAdded: true, content: 'Check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine any plants covering the numbers or blocking the view fro mthe street. Check unit at night to verify operation of installed lighting if any Check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine', repeatPeriod: 0, itemName: 'Address Numbers', percentage: 100, items: { available: ['Samsung New Cooktop Electric with Marble Surface', 'Mitsubishi Cooktop (Electric) 2020'], applied: ['Bosh - 800 Series 36" Electric Induction Cooktop'] } },
    //   { id: 5, isAdded: true, content: 'A check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine any plants covering the numbers or blocking the view fro mthe street. Check unit at night to verify operation of installed lighting if any Check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine', repeatPeriod: 0, itemName: 'Address Numbers', percentage: 100, items: { available: ['Samsung New Cooktop Electric with Marble Surface', 'Mitsubishi Cooktop (Electric) 2020'], applied: ['Bosh - 800 Series 36" Electric Induction Cooktop'] } },
    //   { id: 2, isAdded: false, content: 'A 60% check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine any plants covering the numbers or blocking the view fro mthe street. Check unit at night to verify operation of installed lighting if any Check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine any plants covering the numbers or blocking the view fro mthe street. Check unit at night to verify', repeatPeriod: 1, itemName: 'Exhaust Fans', percentage: 60, items: { available: ['Samsung New Cooktop Electric with Marble Surface', 'Mitsubishi Cooktop (Electric) 2020'], applied: ['Bosh - 800 Series 36" Electric Induction Cooktop'] } },
    //   { id: 3, isAdded: false, content: 'B 33% check for loose or missing numbers or numbers obscured by trees or vines. Clean, paint of polish as needed Trim or prine any plants covering the numbers or blocking the view fro mthe street. Check unit at night to verify operation of installed lighting if any Check for loose or missing numbers or numbers obscured by .', repeatPeriod: 1, itemName: 'Lint Trap and Blower', percentage: 33, items: { available: ['Samsung New Cooktop Electric with Marble Surface', 'Mitsubishi Cooktop (Electric) 2020'], applied: ['Bosh - 800 Series 36" Electric Induction Cooktop'] } },
    //   { id: 4, isAdded: false, content: 'C 0% check for loose or missing numbers or numbers obscured by trees or vines. to verify operation of installed lighting if any Check for loose or missing numbers or numbers obscured by .', repeatPeriod: 1, itemName: 'Lint Trap and Blower', percentage: 0, items: null}
    // ]

    renderAddButton = (id, isAdded, isDisabled) => {
      return (
        <button
          className={isAdded ? 'btn btn-primary btn-siteone' : 'btn btn-siteone-default'}
          disabled={isDisabled ? 'disabled' : ''} >
          {isAdded ? 'Added' : 'Add'}
        </button>
      );
    }

  renderProgress = (percentage) => {
    const pathColor = percentage < 100 ? '#09BFDF' : '#1FBC70';

    return (
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        strokeWidth={10}
        styles={buildStyles({
          textSize: '24px',
          textColor: 'black',
          textFontWeight: 'bold',
          pathColor: pathColor
        })}
      />
    );
  }

  compareSpecificTasks = (a, b) => {
    if ((a.percentage === 100 && b.percentage === 100) ||
    (a.percentage < 100 && b.percentage < 100)) {
      return a.inventoryItemName.localeCompare(b.inventoryItemName);
    }

    return a.percentage - b.percentage;
  }

  renderAvailableTaskList = () => {
    return (
      <div className='task-list'>
        {
          Array.isArray(this.props.suggestedSpecificTaskList) &&
          this.props.suggestedSpecificTaskList
            .filter(e => e.percentage !== null)
            .sort((a, b) => this.compareSpecificTasks(a,b))
            .map((e, i) => {
              if (this.state.filterOutItems[e.id] === 1) {return null;}

              return (
                <div key={i} className='row'>
                  <div className='col-md-7'>
                    <div style={{float: 'left'}}>
                      {this.renderAddButton(e.id, e.isAdded, false)}
                    </div>

                    <div className='block-with-text'>
                      {e.description}
                    </div>
                  </div>

                  <div className='col-md-1'>
                    <div style={{width: '40px', margin: 'auto', cursor: 'pointer'}}>
                      <OverlayTrigger
                        placement='top'
                        delayHide={10}
                        delayShow={500}
                        overlay={this.renderToolTipForTask(e.applieds, e.notApplieds)}
                      >
                        <span>{this.renderProgress(e.percentage)}</span>
                      </OverlayTrigger>
                    </div>
                  </div>

                  <div className='col-md-2'>
                    <img className='icon' src={flag_black_icon} />
                    <div className='sub-block-text'>
                      {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
                    </div>
                  </div>

                  <div className='col-md-2' style={{position: 'relative'}}>
                    <img className='icon' src={cube_icon} />
                    <div className='sub-block-text'>
                      {e.inventoryItemName}
                    </div>
                  </div>
                </div>
              );
            }
            )
        }
      </div>
    );
  }

  renderNotAvailableTaskList = () => {
    return (
      <div className='task-list'>
        <b style={{color: 'gray'}}>Not Available</b>
        <OverlayTrigger
          placement='top'
          delayHide={10}
          delayShow={500}
          overlay={this.toolTipNotAvailable()}
        >
          <i
            className='fa fa-question-circle'
            style={{width: '32px', fontSize: '18px', verticalAlign: 'bottom'}}
          />
        </OverlayTrigger>
        {
          Array.isArray(this.props.suggestedSpecificTaskList) &&
          this.props.suggestedSpecificTaskList
            .filter(e => e.percentage === null)
            .sort((a,b) => a.inventoryItemName.localeCompare(b.inventoryItemName))
            .map((e, i) => {
              if (this.state.filterOutItems[e.id] === 1) {return null;}

              return (
                <div key={i} className='row'>
                  <div className='col-md-7'>
                    <div style={{float: 'left'}}>
                      {this.renderAddButton(e.id, e.isAdded, true)}
                    </div>

                    <div className='block-with-text'>
                      {e.description}
                    </div>
                  </div>

                  <div className='col-md-1'>
                    <div style={{width: '40px', margin: 'auto'}} />
                  </div>

                  <div className='col-md-2'>
                    <img className='icon' src={flag_black_icon} />
                    <div className='sub-block-text'>
                      {MaintenanceEnums.REPEAT_PERIODS_LIST[e.repeatType]}
                    </div>
                  </div>

                  <div className='col-md-2' style={{position: 'relative'}}>
                    <img className='icon' src={cube_icon} />
                    <div className='sub-block-text'>
                      {e.inventoryItemName}
                    </div>
                  </div>
                </div>
              );
            }
            )
        }
      </div>
    );
  }

  toolTipNotAvailable() {
    return (
      <Tooltip className='tooltip-siteone' id='tool-tip-not-available'>
        <span>This section contains suggested maintenance tasks for inventory items which are not added to this project.</span>
      </Tooltip>
    );
  }

  renderToolTipForTask(applieds, notApplieds) {
    return (
      <Tooltip className='import-task tooltip-siteone' id='tool-tip-items'>
        <div>Available inventory items to apply this maintenance task:</div>
        {notApplieds.map(e => (<div>- {e}</div>))}
        <br/>
        <div>Inventory items applied this maintenance task:</div>
        {applieds.map(e => (<div>- {e}</div>))}
      </Tooltip>
    );
  }

  searchTemplate = () => {
    if (this.boxSearchRef) {
      let filterOutItems = {};
      const keyword = this.boxSearchRef.value.toLowerCase();

      this.props.suggestedSpecificTaskList.map(e => {
        if (!e.description.toLowerCase().includes(keyword) &&
        !e.inventoryItemName.toLowerCase().includes(keyword)) {
          filterOutItems[e.id] = 1;
        }
      });

      this.setState({filterOutItems: filterOutItems});
      console.log(this.boxSearchRef.value);
    }
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.searchTemplate();
    }
  }

  renderSearchBox = () => {
    return (
      <div className='box-search'>
        <div className='input-group combo'>
          <input
            type='text'
            className='form-control'
            placeholder='task name, inventory item'
            onKeyPress={this.onKeyPress}
            ref={ref => {this.boxSearchRef = ref;}}
          />
          <span className='input-group-btn'>
            <button className='btn btn-secondary' onClick={this.searchTemplate}>
              <span className='fa fa-search' />
            </button>
          </span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderSearchBox()}
        {this.renderAvailableTaskList()}
        {this.renderNotAvailableTaskList()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    suggestedSpecificTaskList: state.ProjectStore.SuggestedSpecificTaskList
  };
};

export default connect(mapStateToProps)(MaintenanceImportTaskSpecific);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-import-specific.js